export const SUBJECT_COLORS = {
  turkce: { badge: "bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300", hex: "#ef4444", bar: "#ef4444" },
  matematik: { badge: "bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300", hex: "#3b82f6", bar: "#3b82f6" },
  fen: { badge: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300", hex: "#10b981", bar: "#10b981" },
  sosyal: { badge: "bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300", hex: "#f59e0b", bar: "#f59e0b" },
  ingilizce: { badge: "bg-purple-100 text-purple-800 dark:bg-purple-900/40 dark:text-purple-300", hex: "#8b5cf6", bar: "#8b5cf6" },
  din: { badge: "bg-teal-100 text-teal-800 dark:bg-teal-900/40 dark:text-teal-300", hex: "#14b8a6", bar: "#14b8a6" },
};

export const PALETTES = [
  { id: "suleymaniye", name: "Turkuaz & Turuncu", color: "#0d7d76" },
  { id: "sapphire_academy", name: "Safir Mavisi", color: "#1e3a8a" },
  { id: "emerald_science", name: "Zümrüt Yeşili", color: "#047857" },
  { id: "burgundy_classic", name: "Bordo Klasik", color: "#881337" },
  { id: "slate_tactical", name: "Obsidyen", color: "#0f172a" },
];

export const subjectColor = (key) => SUBJECT_COLORS[key] || { badge: "bg-slate-100 text-slate-700", hex: "#64748b", bar: "#64748b" };

export const ROLE_LABELS = { admin: "Yönetici", teacher: "Öğretmen", staff: "Personel", viewer: "Görüntüleyici" };
